import React from 'react';
import { useAuth } from 'oidc-react';
import { APIHandler, DataHandler, StorageHandler } from 'C4';
import { storageKeys } from 'settings';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Logo from 'assets/images/logo/logo.png';

import { ToastContainer, toast, cssTransition } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Zoom = cssTransition({
  enter: 'zoomIn',
  exit: 'zoomOut',
  duration: [500, 800],
});

const SSOView = () => {
  // Check if user exists at TravPRO and check all required fields are set,
  // if not show register form, if yes login + create object
  const auth = useAuth();

  if (auth && auth.userData && auth.userData.profile) {
    APIHandler.getUser(500, auth.userData.profile.username).then((userInfo) => {
      if (APIHandler.ok(userInfo.response)) {
        // Check if all required fields are set, if not redirect to form
        const { email, state } = userInfo.response;
        const firstName = userInfo.response.first_name;
        const lastName = userInfo.response.last_name;
        const agencyName = userInfo.response.agency_name;

        if (email && firstName && lastName && agencyName && state) {
          // Succesfully logged in + complete profile
          const { year } = StorageHandler.expire;
          StorageHandler.save(storageKeys.user, userInfo, year);
          window.location.href = '/selector';
        } else {
          // Profile not complete
          window.location.href = '/register';
        }
      } else {
        // Not in TravPRO system, register
        window.location.href = '/register';
      }
    });
  } else {
    // No user available, currently not used because this object is empty the first time.
    // toast.error('Login failed, please try to log out and log back in. If this doesn\'t resolve your issue, please contact support at info@travpromobile.com.', {
    //   position: 'bottom-center',
    //   transition: Zoom,
    //   autoClose: 10000,
    //   hideProgressBar: true,
    //   closeOnClick: true,
    //   pauseOnHover: true,
    //   draggable: true,
    // });
  }

  return (
    <div className="magicLinkView">
      <div className="sso-bg" />
      <ToastContainer />
      <div className="sso-content">
        <img src={Logo} className="logo" alt="Logo" />
        <span className="spinner">
          <FontAwesomeIcon icon={['fas', 'circle-notch']} spin />
        </span>
        <p>{'Please wait, we are signing you in right now.'}</p>
      </div>
    </div>
  );
};

export default SSOView;
